"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_PRODUCT_FIELDS = exports.STANDARD_PRODUCT_FIELDS = exports.CUSTOM_PRODUCT_FIELDS = exports.ORIGINAL_PRODUCT_FIELDS = void 0;
const attributes_1 = require("../../../../../constants/attributes");
exports.ORIGINAL_PRODUCT_FIELDS = Object.values(attributes_1.OriginalProductAttributes);
exports.CUSTOM_PRODUCT_FIELDS = Object.values(attributes_1.CustomProductAttributes);
exports.STANDARD_PRODUCT_FIELDS = [...exports.ORIGINAL_PRODUCT_FIELDS, ...exports.CUSTOM_PRODUCT_FIELDS];
exports.BASE_PRODUCT_FIELDS = [attributes_1.PRODUCT_IMAGE_LABEL, attributes_1.PRODUCT_PAGE_URL_LABEL];
